import { createContext, useContext } from 'react';

type NestedFilterSelectContextValue = {
  selectedValue: string | null;
  onSelectValue: (value: string, groupLabel: string | null) => void;
  registerValueGroup: (value: string, groupLabel: string | null) => void;
};

export const NestedFilterSelectContext =
  createContext<NestedFilterSelectContextValue | null>(null);

export function useNestedFilterSelectContext(): NestedFilterSelectContextValue {
  const ctx = useContext(NestedFilterSelectContext);
  if (ctx === null) {
    throw new Error(
      'NestedFilterSelect.Item must be rendered inside <NestedFilterSelect>'
    );
  }
  return ctx;
}

export const NestedFilterSelectGroupContext = createContext<string | null>(
  null
);
